import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const Labor = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Labor & Employment Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              We advise employers and employees on the full spectrum of labor
              and employment law issues, ensuring fair practices and legal
              compliance in the workplace. Our services cover employment
              contracts, workplace policies, industrial disputes, termination
              matters, collective bargaining, and representation before labor
              courts and industrial tribunals. We also counsel on compliance
              with labor welfare legislations, social security laws, and
              occupational safety standards. Our objective is to balance
              organizational needs with employee rights, fostering a compliant
              and harmonious workplace environment.
            </p>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default Labor;
